import { Component, Input } from '@angular/core';
import { ProjectElement } from '../../project-element.interface';
import { ElementLog } from '../../../../utilities/stores/element-log/element-log.interface';
import { ElementService } from '../../element.service';
import { take, skip } from 'rxjs/operators';

/**
 * Log comment box.
 *
 * The comment box at the bottom of the element log sidebar.
 */
@Component({
  selector: 'sg2-element-logs-comment-box',
  templateUrl: './comment-box.component.html',
  styleUrls: ['./comment-box.component.less']
})
export class ElementLogsCommentBoxComponent {

  /** Element binding. */
  @Input() element: ProjectElement;

  /** Comment. */
  public comment: ElementLog['text'];

  /** Constructor. */
  constructor(
    private elementService: ElementService
  ) { }

  /**
   * Submit comment, and add to the element.
   *
   * Scrolls back to top after adding new comment.
   *
   * @todo Add smooth scroll.
   */
  public submit(): void {
    this.elementService.addComment(this.element, this.comment);
    this.comment = '';

    this.elementService.element$.pipe(skip(1), take(1)).subscribe(() => {
      document.getElementById('element-sidebar-comments').scrollIntoView({ behavior: 'smooth' });
    });
  }

}
